<template>
  <el-dialog
    title="设置控制价"
    :visible.sync="visible"
    append-to-body
    class="dialog"
  >
    <kpb-open-control-price-form
      ref="controlPriceForm"
      :project-id="projectId"
      :offer-unit="offerUnit"
      :control-price-config="controlPriceConfig"
    />
    <div slot="footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import KpbOpenControlPriceForm from '@/components/kpb/open/KpbOpenControlPriceForm.vue'

export default {
  name: 'KpbOpenControlPriceDialog',

  components: { KpbOpenControlPriceForm },

  props: {
    // 报价单位,根据项目的
    offerUnit: {
      type: String,
      default: ''
    },

    projectId: {
      type: [String, Number],
      default: ''
    },

    // 控制价信息
    controlPriceConfig: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      visible: false
    }
  },

  methods: {
    onCancel() {
      this.$refs.controlPriceForm.resetForm()
      this.visible = false
    },

    onConfirm() {
      this.$refs.controlPriceForm.submitForm().then(() => {
        this.$emit('reload')
        this.onCancel()
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
